<template>
  <div>
    <template v-if="!loading">
      <div style="display: block; overflow-x: auto; white-space: nowrap;">
      <table style="width: 600px;" class="table-orders">
        <thead>
          <tr>
            <th class="text-center" >วันที่</th>
            <th class="text-center" >หมายเลขรับประกันสินค้า</th>
            <th class="text-center" >รหัสรุ่นสินค้า</th>
            <th class="text-center" >ของขวัญ / ซื้อ</th>
            <th class="text-center" >ยอดซื้อสะสม</th>
            <th class="text-center" >สถานะ</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="dataHistory.length > 0">
            <tr v-for="(item,i) in dataHistory" :key="i">
              <td class="text-center">{{ moment(item.timestamp).add(543, "year").format("DD/MM/YYYY") }}</td>
              <td class="text-center">{{ item.warranty_number }}</td>
              <td class="text-center">{{ item.sku }}</td>
              <td class="text-center">{{ item.types }}</td>
              <td class="text-center">{{ item.amounts | formatNumber }}</td>
              <td class="text-center">
                <template v-if="item.status =='pending'">รอการตรวจสอบ</template>
                <template v-else>บันทีกยอดสะสมแล้ว</template>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="6" class="text-center">ไม่มีรายการประวัติการสั่งซื้อ</td>
            </tr>
          </template>
        </tbody>
      </table>
      </div>
    </template>
    <template v-else >
      <div class="text-center">
        <v-progress-circular
          indeterminate
          class="-4"
          color="primary"
          size="32"
        ></v-progress-circular>
      </div>
    </template>
  </div>
</template>

<script>
  import axios from "axios";
  import moment from "moment";

  export default {
   data() {
      return {
        limit: 10,
        offset: 0,
        dataHistory: [],
        loading: false,
      }
    },
    mounted() {
      this.getHistoryOrders();
    },
    computed: {
      moment() {
        return moment;
      }
    },
    methods: {
      getHistoryOrders() {
        return new Promise((resolve) => {
          var data = { 
            member_id: this.$store.state.member.id, 
            limit: this.limit,
            offset: this.offset
          };

          this.loading = true;
          axios
            .get(this.serverUrl + "lamy/rewardPoints", {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
              params: data,
            })
            .then(async (response) => {
              if(response.data.responsecode == 200) {
                this.dataHistory = response.data.data;
                this.loading = false;
                
              } else {
                await this.$swal.fire({ text: response.data.reason, confirmButtonColor: '#000' });
                this.$liff.closeWindow();
              }
              resolve();
            });
        });
      },
    }
  }
</script>

<style lang="scss" scoped>
.table-orders {
  border-collapse: collapse;
  margin-bottom: 12px;
  tr {
    font-size: 13px;
    td {
      font-size: 12px;
      border-bottom: 1px solid #ccc;
      padding: 8px 0;
    }
  }
}
</style>